import { apiBaseUrl } from "./auth";
import { getStoredLanguage } from "../context/I18nContext";
import i18n from "../i18n";

const STUDENTS_BASE = `${apiBaseUrl}/api/auth/students`;

async function request(
  path = "/",
  { accessToken, params, method = "GET", body } = {},
) {
  if (!accessToken) {
    throw new Error(i18n.t("errors.authRequired"));
  }

  const headers = {
    Accept: "application/json",
    Authorization: `Bearer ${accessToken}`,
    "Accept-Language": getStoredLanguage(),
  };

  if (body) {
    headers["Content-Type"] = "application/json";
  }

  const queryParams = params
    ? { ...params, lang: getStoredLanguage() }
    : { lang: getStoredLanguage() };
  const queryString = `?${new URLSearchParams(queryParams).toString()}`;

  const response = await fetch(`${STUDENTS_BASE}${path}${queryString}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  const isJson = response.headers
    .get("content-type")
    ?.includes("application/json");
  const payload = isJson ? await response.json() : {};

  if (!response.ok) {
    const message = payload.error || i18n.t("errors.fetchFailed");
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }

  return payload;
}

export function fetchStudents({ accessToken, parentId, page } = {}) {
  const params = {};
  if (parentId) params.parent_id = parentId;
  if (page) params.page = page;
  return request("/", { accessToken, params });
}

export function createStudent(accessToken, payload) {
  return request("/", {
    accessToken,
    method: "POST",
    body: payload,
  });
}

export function updateStudent(accessToken, studentId, payload) {
  return request(`/${studentId}/`, {
    accessToken,
    method: "PATCH",
    body: payload,
  });
}

export function deleteStudent(accessToken, studentId) {
  return request(`/${studentId}/`, {
    accessToken,
    method: "DELETE",
  });
}
